import { CSProductDetails } from '@websrc/Typings/ContentStack'
import React from 'react'

import { table } from './ComparisonTable.css'

interface ComparisonTableSelctTrProps {
  isMobile: boolean
  products: CSProductDetails[]
  setVisibleProductIndex: React.Dispatch<React.SetStateAction<number>>
}

export function ComparisonTableSelectTr({
  isMobile,
  products,
  setVisibleProductIndex,
}: ComparisonTableSelctTrProps) {
  return (
    isMobile && (
      <tr>
        <th> </th>
        <th className={table.thead.selectTh}>
          <select
            onChange={(event) => {
              setVisibleProductIndex((event.target as HTMLSelectElement).selectedIndex)
            }}
          >
            {products.map((product, i) => (
              <option key={i}>{product.name}</option>
            ))}
          </select>
        </th>
      </tr>
    )
  )
}
